module.exports = __webpack_public_path__ + "img/3.874b1705.png";